import axios from '@/axios.js';

export default {
  methods: {
    async goToURL(value, platform) {
      if (!value || this.editor) return;

      let url = value;
      if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url;
      }

      const FingerprintJS = await import(
        /* webpackChunkName: "fingerprint" */
        '@fingerprintjs/fingerprintjs'
      );

      let visitorId = localStorage.getItem('visitorId') || (await FingerprintJS.load().then(fp => fp.get().then(result => {
        localStorage.setItem('visitorId', result.visitorId);
        return result.visitorId;
      }))).catch(error => console.error("Fingerprint error:", error));

      try {
        await axios.post('/set-site-click', {
          site_id: this.harmony.id,
          url: url,
          platform: platform,
          fingerprint: visitorId
        });

        window.location.href = url;
      } catch (error) {
        window.location.href = url;
        console.error('Error al registrar el clic:', error);
      }
    },

    async navigateToCard(card, src) {
      if (this.editor) return;

      const name = card?.name?.split('/')[0]?.toLowerCase() || '';
      const show = typeof src === 'object' ? src.show : true;
      const srcPath = typeof src === 'object' ? src.path : src;

      const url = card?.url2 || card?.url;
      if (url) {
        if (this.platformsAdult.includes(name)) {
          const result = await this.$swal({
            title: `<strong style="font-size: 14px;">${this.$t('harmony.contentExplicit')}</strong>`,
            html: `<p style="font-size: 12px; margin-bottom: 10px;">${this.$t('harmony.content+18')}</p>`,
            width: 326,
            heightAuto: false,
            customClass: {
              icon: 'notborder',
              title: 'titleSwal',
              popup: 'containerSwal',
              htmlContainer: 'htmlContainerSwal',
              actions: 'actionsSwal',
              confirmButton: 'confirmButtonSwal',
              cancelButton: 'cancelButtonSwal',
            },
            showCancelButton: true,
            confirmButtonText: `<i class="fa fa-thumbs-up"></i> ${this.$t('harmony.showContentExplicit')}`,
            cancelButtonText: `${this.$t('harmony.hideContentExplicit')}`,
            confirmButtonColor: '#35bd5d',
            cancelButtonColor: '#d33',
            background: '#f2f2f2',
            backdrop: `rgba(0, 0, 0, 0.7) no-repeat`,
          });

          if (!result.isConfirmed) return;
        }

        return this.goToURL(url, name);
      }

      if (!srcPath) return;

      if (!this.imageExtensions) {
        this.imageExtensions = new Set(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']);
        this.videoExtensions = new Set(['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv']);
      }

      if (!show && !(await this.showAlert())) {
        return;
      }

      const extension = srcPath.split('.').pop()?.toLowerCase();

      if (this.imageExtensions.has(extension)) {
        this.isModalOpen = true;
        this.selectedMediaSrc = srcPath;
        this.selectedMediaType = 'image';
      } else if (this.videoExtensions.has(extension)) {
        this.isModalOpen = true;
        this.selectedMediaSrc = srcPath;
        this.selectedMediaType = 'video';
      }
    }
  }
}
